export default {
  SET_DESCRIPTION(state, { payload, audience }) {
    const keys = Object.keys(payload);
    const finalArray = [];
    for (let i = 0; i < keys.length; i++) {
      const tempObj = {};
      if (payload[keys[i]] !== '') {
        tempObj['data'] = payload[keys[i]];
        switch (keys[i]) {
          case 'ObjectiveText':
            if (audience === 'individual') {
              tempObj['label'] = 'Fund Objective';
            } else {
              tempObj['label'] = 'Objective';
            }
            break;
          case 'Maturity':
            tempObj['label'] = 'Maturity';
            break;
          case 'NonUSHoldings':
            tempObj['label'] = 'Holdings Outside the U.S';
            break;
          case 'PortfolioRestrictions':
            tempObj['label'] = 'Portfolio Restrictions';
            break;
          case 'SpecialCharacteristics':
            tempObj['label'] = 'Distinguishing Characteristics';
            break;
          case 'InvestmentType':
            tempObj['label'] = 'Types of Investments';
            break;
          default:
            break;
        }
        finalArray.push(tempObj);
      }
    }
    state.description = finalArray;
  }
};
